import { PriceDotIndicator } from "@apac/ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { useCalendarDay, type IDayProps } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const Day = (props: IDayProps) => {
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.DatePickerDay);

  const { priceBucket, dayLabel, className } = props;

  const {
    context: { isFocusedDate, currentDateRef, styleConditions, disabledDate },
    handlers,
  } = useCalendarDay(props);

  return (
    <button
      className={clsx(block, className, cn("root", styleConditions))}
      aria-label={handlers.getDayAriaLabel()}
      tabIndex={isFocusedDate && !disabledDate ? 0 : -1}
      ref={!disabledDate ? currentDateRef : null}
      {...handlers}
    >
      <div className={cn("label-wrapper")}>
        <div className={cn("day-label")}>{dayLabel}</div>
        {priceBucket !== undefined && (
          <PriceDotIndicator
            priceBucket={priceBucket}
            className={cn("price-dot-indicator")}
          />
        )}
      </div>
    </button>
  );
};
